module.exports = __webpack_public_path__ + "static/media/certified-pro-banner-desktop.682fc2ea.png";